import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { ID_LEVEL0_INDUSTRY } from '../constant'
import { initCollapseById } from '../helper'
import { getIndustry } from './thunk'

const initialState = {
  loading: true,
  dataById: {},
  value: [],
  collapse: {},
}

const slice = createSlice({
  name: 'portfolioInsights/segment/portfolioIndustry',
  initialState,
  reducers: {
    initCollapse: (state, action) => {
      state.collapse = initCollapseById(action.payload)
    },
    close: (state, action) => {
      const { rowId, childrenIds } = action.payload
      state.collapse[rowId].isOpen = false
      childrenIds.forEach((id) => {
        state.collapse[id].collapsedBy.push(rowId)
      })
    },
    open: (state, action) => {
      const { rowId, childrenIds } = action.payload
      state.collapse[rowId].isOpen = true
      childrenIds.forEach((id) => {
        state.collapse[id].collapsedBy = state.collapse[id].collapsedBy.filter(
          (item) => item !== rowId,
        )
      })
    },
    resetIndustry: (state) => {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getIndustry.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getIndustry.fulfilled, (state, action) => {
      state.value = Array.isArray(action.payload)
        ? action.payload.filter((item) => item.vsicId !== ID_LEVEL0_INDUSTRY)
        : []
      state.dataById = keyBy(action.payload, 'vsicId')
      state.loading = false
    })
    builder.addCase(getIndustry.rejected, (state, action) => {
      state.loading = action.payload.loading
    })
  },
})

export const { initCollapse, close, open, resetIndustry } = slice.actions

export const selectSegmentIndustry = (state) => state[slice.name].value
export const selectCellData = (id, attr) => (state) =>
  state[slice.name].dataById?.[id]?.[attr]
export const selectRowData = (rowId) => (state) =>
  state[slice.name].dataById[rowId]
export const selectLoading = (state) => state[slice.name].loading
export const selectCollapseInfoById = (rowId) => (state) =>
  state[slice.name].collapse[rowId]
export const selectCollapse = (state) => state[slice.name].collapse
export const selectDataById = (state) => state[slice.name].dataById

register(slice.name, slice.reducer)
